import moment from 'moment'

export default (date: string, withTime = false): string => {
    return moment(date).format(withTime ? 'lll' : 'll')
}
